import { mergeClasses, Spinner, SpinnerProps } from "@fluentui/react-components";
import { memo, ReactNode } from "react";
import { useLoadingStyles } from "./styles";

type LoadingProps = SpinnerProps & {
  className?: string;
};

export const Loading = memo(({ className, ...props }: LoadingProps) => {
  const styles = useLoadingStyles();

  return (
    <div className={mergeClasses(styles.container, className ?? "")}>
      <Spinner appearance="primary" {...props} />
    </div>
  );
});

type LoadingContainerProps = LoadingProps & {
  isLoading: boolean;
  children: ReactNode;
};

export const LoadingContainer = memo(({ isLoading, children, ...props }: LoadingContainerProps) => {
  if (!isLoading) return <>{children}</>;
  return <Loading {...props} />;
});
